import React from "react";
import Buscador from "../Buscador";
import Description from "../Description";
import Titulos from "../Titulos/index";
import WeatherImg from "../WeatherImg/index";
import "./index.css";
import viento from "../viento";
import img from "./img/ventilador.svg";
import Grafico from "../Grafico/index";

const Card = (props) => {
  const {
    text,
    link,
    desc,
    condition,
    paises,
    onChange,
    wind,
    windDir,
    datosGrafico,
    datosGraficot,
    horaLocal,
  } = props;
  const direccion = viento[windDir];
  return (
    <div className="Card">
      <Buscador paises={paises} onChange={onChange} />
      <Description desc={desc} />
      <Description desc={horaLocal} />
      <Titulos text={text} />
      <WeatherImg link={link} />
      <Description desc={condition} />
      <img className="App-logo" src={img} alt="viento" width="50px" />
      <Description desc={"Viento Direccion " + direccion} />
      <Description desc={"Velocidad " + wind + "Km/h"} />
      <Grafico datosGrafico={datosGrafico} datosGraficot={datosGraficot} />
    </div>
  );
};

export default Card;
